<div class="international-phone-field" [class.use-iftalabel]="useIftaLabel">
    @if (!useIftaLabel && label) {
        <label [for]="inputId" class="external-label">
            {{ label }}
            @if (required) { <b class="required-marker">*</b> }
        </label>
    }

    @if (useInputGroup) {
        <p-inputgroup [class.ng-invalid]="validate()" [class.ng-dirty]="hasValue" [class]="styleClass || ''">
            @if (dialingCodePlacement === 'combined') {
                <p-inputgroup-addon class="phone-icon-addon combined">
                    @if (showIcon && icon) {
                        <i [class]="icon"></i>
                    }
                    @if (dialingCode) {
                        <span class="dialing-code-text">{{ dialingCode }}</span>
                    }
                </p-inputgroup-addon>
            } @else {
                @if (showIcon && icon) {
                    <p-inputgroup-addon class="phone-icon-addon">
                        <i [class]="icon"></i>
                    </p-inputgroup-addon>
                }
                @if (dialingCodePlacement === 'separate' && dialingCode) {
                    <p-inputgroup-addon class="dialing-code">{{ dialingCode }}</p-inputgroup-addon>
                }
            }

            @if (useIftaLabel) {
                <p-iftalabel class="phone-iftalabel">
                    <input
                        [id]="inputId"
                        pInputText
                        type="tel"
                        inputmode="tel"
                        autocomplete="tel"
                        [value]="displayValue"
                        [placeholder]="inputPlaceholder"
                        [disabled]="disabled"
                        (input)="onInput($event)"
                        (blur)="onBlur()">
                    <label [for]="inputId">
                        {{ label }}
                        @if (required) { <b>*</b> }
                    </label>
                </p-iftalabel>
            } @else {
                <input
                    [id]="inputId"
                    pInputText
                    type="tel"
                    inputmode="tel"
                    autocomplete="tel"
                    [value]="displayValue"
                    [placeholder]="inputPlaceholder"
                    [disabled]="disabled"
                    (input)="onInput($event)"
                    (blur)="onBlur()">
            }
        </p-inputgroup>
    } @else {
        @if (useIftaLabel) {
            <p-iftalabel class="phone-iftalabel">
                <input
                    [id]="inputId"
                    pInputText
                    type="tel"
                    inputmode="tel"
                    autocomplete="tel"
                    [value]="displayValue"
                    [placeholder]="inputPlaceholder"
                    [disabled]="disabled"
                    (input)="onInput($event)"
                    (blur)="onBlur()">
                <label [for]="inputId">
                    {{ label }}
                    @if (required) { <b>*</b> }
                </label>
            </p-iftalabel>
        } @else {
            <input
                [id]="inputId"
                pInputText
                type="tel"
                inputmode="tel"
                autocomplete="tel"
                [value]="displayValue"
                [placeholder]="inputPlaceholder"
                [disabled]="disabled"
                (input)="onInput($event)"
                (blur)="onBlur()">
        }
    }

    @if (showHelperText || helperText) {
        <small class="phone-helper-text">
            {{ helperText || (dialingCode ? 'Saved as an international number beginning with ' + dialingCode + '.' : 'Select a country with a calling code before entering a mobile number.') }}
        </small>
    }
</div>
